import { Button } from '@parcel/ui';
import { Link } from '@tanstack/react-router';
import { Newspaper } from 'lucide-react';
import { EmptyState } from '../empty-state.js';

/** Nothing followed yet: the Feed only shows followed accounts and projects. */
export function FeedEmpty({ linkFor }: { linkFor: (to: `/${string}`) => string }) {
  return (
    <EmptyState
      icon={<Newspaper className="size-5 text-muted-foreground" />}
      title="Nothing followed yet"
      description="Follow an account or a project to see what changes here."
      action={
        <div className="flex justify-center gap-2">
          <Button asChild variant="outline">
            <Link to={linkFor('/accounts')}>Accounts</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to={linkFor('/projects')}>Projects</Link>
          </Button>
        </div>
      }
    />
  );
}
